import React, { useState, useEffect } from "react";
import "./BetaAnnouncementBar.scss";

export const BETA_SITE_URL = "https://app.trainermetrics.com/";
const SESSION_KEY = "beta_announcement_bar_dismissed";

/**
 * Top-of-page announcement bar inviting users to switch to Version 3.
 *
 * - Renders above the header.
 * - Whole bar is a clickable link to the Version 3 site.
 * - The X (close) button dismisses the bar for the current session only;
 *   it reappears on the next visit/login since `sessionStorage` is cleared
 *   when the tab closes.
 */
const BetaAnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem(SESSION_KEY) === "1") {
      setDismissed(true);
    }
  }, []);

  // Apply a class to <body> while the bar is visible so the layout
  // (fixed sidebar, sticky header) can push down to make room.
  useEffect(() => {
    if (typeof document === "undefined") return;
    const cls = "has-beta-announcement-bar";
    if (!dismissed) {
      document.body.classList.add(cls);
    } else {
      document.body.classList.remove(cls);
    }
    return () => document.body.classList.remove(cls);
  }, [dismissed]);

  const handleClose = () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(SESSION_KEY, "1");
    }
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="beta-announcement-bar" role="banner">
      <span className="beta-announcement-bar__text">
        We've redesigned TrainerMetrics —{" "}
        <a
          href={BETA_SITE_URL}
          className="beta-announcement-bar__cta"
          aria-label="Switch to Version 3"
        >
          try Version 3
        </a>
      </span>
      <button
        type="button"
        className="beta-announcement-bar__close"
        onClick={handleClose}
        aria-label="Dismiss announcement"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default BetaAnnouncementBar;
